// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adMain {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 27px;
}

.adContent {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 24px;
    align-items: center;
    justify-content: center;
    padding: 0 0 120px 0;
}

.adSlider {
    width: 100%;
    align-items: flex-end;
    justify-content: flex-end;
}

.adDataColumn {
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    padding: 0 16px;
}

.adDataLine {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.adDataTitle {
    font-family: Alegreya Sans;
    font-size: 32px;
    font-weight: 700;
    line-height: 38.4px;
    text-align: left;
    color: #4B2D10;
    width: calc(100% - 44px);
}

.adDataButtonChat {
    width: 100%;
    height: auto;
    padding: 8px 99px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Alegreya Sans;
    font-size: 20px;
    font-weight: 700;
    line-height: 16px;
    text-align: left;
    color: #FFF4D9;
    background: #FF6B00;
    border: none;
    height: 36px;
}

.adDataLilColumn {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    align-items: left;
    justify-content: left;
}

.adDataSubtitle {
    font-family: Alegreya Sans;
    font-size: 24px;
    font-weight: 700;
    line-height: 19.2px;
    text-align: left;
    color: #8E3B00;
}

.adDataText {
    font-family: Alegreya Sans;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.2px;
    text-align: left;
    color: #4B2D10;
}

.adDataLilLine {
    display: flex;
    flex-direction: row;
    gap: 16px;
    width: 100%;
    align-items: left;
    justify-content: left;
}

.adDataTextBig {
    font-family: Alegreya Sans;
    font-size: 20px;
    font-weight: 400;
    line-height: 19.2px;
    text-align: left;
    color: #4B2D10;
}

.adDataBigLine {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: space-between;
}

.adDataSummBlock {
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: left;
    justify-content: space-between;
    border: solid 1px #B48100;
    padding: 7px 12px 8px 6px;
    border-radius: 8px;
    min-width: 118px;
}

.adDataSummText {
    font-family: Alegreya Sans;
    font-size: 16px;
    font-weight: 400;
    line-height: 100%;
    text-align: left;
    color: #4B2D10;
}

.adDataBoxAds {
    width: 100%;
    overflow: auto;
    display: flex;
    align-items: left;
    justify-content: left;
}

.adDataBoxAds::-webkit-scrollbar {
    display: none;
}

.adDataLineAds {
    width: max-content;
    display: flex;
    flex-direction: row;
    gap: 8px;
}

.adBackHeader {
    width: 100%;
    height: 108px;
    border-radius: 0 0 24px 24px;
    background: #FF6B00;
    display: flex;
    flex-direction: row;
    padding: 54px 16px 0 21px;
    align-items: center;
    justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/components/Main/Ad/Ad.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,8BAA8B;AAClC","sourcesContent":[".adMain {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 27px;\n}\n\n.adContent {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 24px;\n    align-items: center;\n    justify-content: center;\n    padding: 0 0 120px 0;\n}\n\n.adSlider {\n    width: 100%;\n    align-items: flex-end;\n    justify-content: flex-end;\n}\n\n.adDataColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n    width: 100%;\n    padding: 0 16px;\n}\n\n.adDataLine {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.adDataTitle {\n    font-family: Alegreya Sans;\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 38.4px;\n    text-align: left;\n    color: #4B2D10;\n    width: calc(100% - 44px);\n}\n\n.adDataButtonChat {\n    width: 100%;\n    height: auto;\n    padding: 8px 99px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: Alegreya Sans;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 16px;\n    text-align: left;\n    color: #FFF4D9;\n    background: #FF6B00;\n    border: none;\n    height: 36px;\n}\n\n.adDataLilColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n    align-items: left;\n    justify-content: left;\n}\n\n.adDataSubtitle {\n    font-family: Alegreya Sans;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 19.2px;\n    text-align: left;\n    color: #8E3B00;\n}\n\n.adDataText {\n    font-family: Alegreya Sans;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 19.2px;\n    text-align: left;\n    color: #4B2D10;\n}\n\n.adDataLilLine {\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    width: 100%;\n    align-items: left;\n    justify-content: left;\n}\n\n.adDataTextBig {\n    font-family: Alegreya Sans;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 19.2px;\n    text-align: left;\n    color: #4B2D10;\n}\n\n.adDataBigLine {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.adDataSummBlock {\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    align-items: left;\n    justify-content: space-between;\n    border: solid 1px #B48100;\n    padding: 7px 12px 8px 6px;\n    border-radius: 8px;\n    min-width: 118px;\n}\n\n.adDataSummText {\n    font-family: Alegreya Sans;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 100%;\n    text-align: left;\n    color: #4B2D10;\n}\n\n.adDataBoxAds {\n    width: 100%;\n    overflow: auto;\n    display: flex;\n    align-items: left;\n    justify-content: left;\n}\n\n.adDataBoxAds::-webkit-scrollbar {\n    display: none;\n}\n\n.adDataLineAds {\n    width: max-content;\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n}\n\n.adBackHeader {\n    width: 100%;\n    height: 108px;\n    border-radius: 0 0 24px 24px;\n    background: #FF6B00;\n    display: flex;\n    flex-direction: row;\n    padding: 54px 16px 0 21px;\n    align-items: center;\n    justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
